<div class="demo-console container-fluid" *ngIf="demoEnv.isDemoRealm()">
  <div class="demo-console__header">
    <h1>Switch demo company</h1>
    <p class="demo-console__lead">Choose a demo account. The dashboard reloads with that company's employees and data.</p>
  </div>

  <mat-card class="active-banner" *ngIf="activePersona">
    <mat-card-content>
      <div class="active-banner__inner">
        <span class="material-symbols-outlined active-banner__icon">business</span>
        <div>
          <div class="active-banner__title">Currently viewing: {{ activePersona.name }}</div>
          <div class="active-banner__meta">
            {{ activePersona.seededEmployeeCount }} employees · company id {{ activePersona.companyAdminId }}
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <p class="switch-status" *ngIf="switching">Signing in and reloading dashboard…</p>
  <p class="switch-error" *ngIf="switchError">{{ switchError }}</p>

  <div class="persona-grid">
    <mat-card
      *ngFor="let p of personas"
      class="persona-card"
      [class.persona-card--active]="isActive(p)"
      [class.persona-card--disabled]="!p.importedLocally || switching"
      (click)="selectPersona(p)"
    >
      <mat-card-content>
        <div class="persona-card__top">
          <div class="persona-card__name">{{ p.name }}</div>
          <span class="persona-card__status persona-card__status--active" *ngIf="isActive(p)">Active</span>
        </div>
        <div class="persona-card__count">{{ p.seededEmployeeCount }}</div>
        <div class="persona-card__count-label">employees in demo</div>
        <div class="persona-card__meta">{{ p.emphasis }}</div>
        <div class="persona-card__action" *ngIf="!isActive(p) && p.importedLocally">Switch to this company</div>
      </mat-card-content>
    </mat-card>
  </div>

  <section class="plan-compare" aria-labelledby="plan-compare-heading">
    <div class="plan-compare__header">
      <h2 id="plan-compare-heading">Compare product tiers</h2>
      <p class="plan-compare__lead">Switch plans to show prospects what Basic, Professional, and Business include during a demo.</p>
    </div>

    <div class="plan-compare__tabs" role="tablist" aria-label="Product tier">
      <button
        *ngFor="let tier of planTiers"
        type="button"
        role="tab"
        class="plan-compare__tab"
        [class.plan-compare__tab--active]="selectedPlanCode === tier.plan_code"
        [attr.aria-selected]="selectedPlanCode === tier.plan_code"
        (click)="selectPlan(tier.plan_code)"
      >
        {{ tier.name }}
      </button>
    </div>

    <mat-card class="plan-compare__panel">
      <mat-card-content>
        <div class="plan-compare__panel-top">
          <div>
            <div class="plan-compare__tier-name">{{ selectedPlan.name }}</div>
            <div class="plan-compare__tagline">{{ selectedPlan.tagline }}</div>
          </div>
          <div class="plan-compare__limits">
            <span>Screencast {{ selectedPlan.screencast_limit }}</span>
            <span>Screenshots {{ selectedPlan.screenshot_interval }}</span>
            <span>{{ selectedPlan.retention }}</span>
          </div>
        </div>

        <ul class="plan-compare__highlights">
          <li *ngFor="let line of selectedPlan.highlights">{{ line }}</li>
        </ul>

        <div class="plan-compare__features">
          <p class="plan-compare__features-title">Included in {{ selectedPlan.name }}</p>
          <ul>
            <li *ngFor="let key of selectedPlan.feature_keys">{{ featureLabel(key) }}</li>
          </ul>
        </div>

        <p class="plan-compare__exclusive" *ngIf="exclusiveFeatures(selectedPlan).length as n">
          <strong>{{ n }} entitlements</strong> in this tier vs lower plans — use Billing in production to upgrade a live account.
        </p>
      </mat-card-content>
    </mat-card>
  </section>

  <mat-card class="info-note">
    <mat-card-content>
      Story sizes are 25 / 100 / 50 employees. The numbers on each card are what is seeded in your local demo database today.
    </mat-card-content>
  </mat-card>
</div>
